import React, { Component } from 'react'
import '../../styles/style.css'
import { Grid, Row, Col } from 'react-bootstrap'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import Chip from 'material-ui/Chip'
import Divider from 'material-ui/Divider'
import DatePicker from 'material-ui/DatePicker'
import CardQuarterHeight from '../../components/cards/CardQuarterHeight'
import CardHalfHeight from '../../components/cards/CardHalfHeight'
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import RaisedButton from 'material-ui/RaisedButton'

import OnOffTabs from './tabs'
import { getAuth, authActions } from '../../../core/auth'

import { paths } from '../../routes'
import { Link, browserHistory } from 'react-router'

const styles = {

card: {
    marginBottom: '20px'
},

date: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '5px'
},

date2: {
    marginTop: '20px',
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '5px'
},

toptext: {
    marginLeft: '20px',
    marginRight: '20px',
    paddingBottom: '5px'
},

midtext: {
    marginLeft: '20px',
    marginRight: '20px',
},

midheader: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '1px',
    fontSize: '14px',
    fontWeight: 'bolder',
    textTransform: 'uppercase'
},

roll: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '10px',
    fontSize: '18px',
    fontWeight: 'bolder'
},

space: {
    height: '60px'
},

spacetop: {
    height: '20px'
},

space2: {
    height: '80px'
},

dialogstyle: {
    marginLeft: '20px',
    marginRight: '20px'
},

cardone: {
    marginTop: '25px',
    marginBottom: '25px'
},

ptext: {
    fontSize: '16px',
    paddingBottom: '25px'
},

buttonOne: {
    marginRight: 25
},

buttonHold: {
    textAlign: 'center',
}

}

class OnOffCampus extends Component {
  render() {
    return (
        <div>
            <div className="subheader">
                <h4>Housing Location</h4>
            </div>
            <Grid>
                <Row>
                      <Col xs={12} md={8} mdOffset={2}>
                          <div style={styles.spacetop}></div>
                          <CardHalfHeight>
                          <p style={styles.ptext}>
                              <b>You have elected to live on campus next year.</b> This app is only for students
                              living on campus in the 2017-18 school year.
                              </p>
                            <p style={styles.buttonHold}>
                              <Link to={paths.HOUSING_GROUP}>
                                  <RaisedButton style={styles.buttonOne} label="Get Started" primary={true} />
                              </Link>
                              <a href="mailto:support@riteclass.com?Subject=First%20Page%20Support">
                                  <RaisedButton className="pref-button" label="Contact Support" primary={true} />
                              </a>
                              </p>
                          </CardHalfHeight>

                      </Col>

                  </Row>
              </Grid>
        </div>



    )
  }
}

const mapStateToProps = createSelector(
  getAuth,
  (currentUser) => ({currentUser})
)

const mapDispatchToProps = Object.assign(
  {},
  authActions
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnOffCampus);



// WEBPACK FOOTER //
// ./src/views/pages/on-off-campus/index.js